export const DELETE_REASONS = [
  { value: "unused", labelKey: "DeleteAccount_Reason Unused" },
  { value: "performance", labelKey: "DeleteAccount_Reason Performance" },
  { value: "games", labelKey: "DeleteAccount_Reason Games" },
  { value: "service", labelKey: "DeleteAccount_Reason Service" },
  { value: "other", labelKey: "DeleteAccount_Reason Other" },
];

export const OTP_LENGTH = 6;

export const OTP_LOCKDOWN_STORAGE_KEY = "delete-account-otp-lockdown-until";

export const OTP_LOCKDOWN_DURATION_MS = 5 * 60 * 1000;
